import { MeasureStruct } from "../../structs/sync-measurer/measure.struct";

export class MeasureRequest {
    public listMeasureStruct: MeasureStruct[] = [];
    public syncMeasurerHash: string = '';
    public idPatient: number | null = null;
}
